export default () => <span class="spinner"></span>;
